import { render, staticRenderFns } from "./UserUser.vue?vue&type=template&id=04217377&scoped=true&"
import script from "./UserUser.vue?vue&type=script&lang=js&"
export * from "./UserUser.vue?vue&type=script&lang=js&"
import style0 from "./UserUser.vue?vue&type=style&index=0&id=04217377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04217377",
  null
  
)

export default component.exports